export default {
  agency: {
    include_agency_image: true,
  },
  campaignQuoteTemplate: {},
  provider: {
    include_provider_alternate_logo: true,
    include_provider_blockout_dates: true,
    include_provider_disclaimers: true,
    include_provider_logo: true,
    include_provider_service_ids: true,
  },
  team: {
    include_image_sizes: true,
    include_team_cover_image: true,
    include_team_lead_agent_member: true,
    include_team_member_count: true,
    include_team_member_user: true,
    include_team_user_ids: true,
  },
  user: {
    include_user_customizable_permissions: true,
    include_user_integrations: true,
    include_user_media_links: true,
  },
}
